import * as React from "react";
import { Grid2 as Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledGrid = styled(Grid)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(6),
    marginLeft: theme.spacing(2)
}));

const CopyrightText = styled(Typography)({
    color: 'white',
    fontSize: '14px',
    fontStyle: 'normal',
    lineHeight: 1.57,
    opacity: 0.5,
    fontWeight: 'lighter',
    "& a": {
        color: 'white'
    }
});

const CopyrightBlock: React.FC = () => {
    return (
        <StyledGrid container>
            <Grid>
                <CopyrightText variant='caption' color="inherit">
                    Copyright &copy; National Committee for Quality Assurance. &nbsp;
                    <a href={process.env.REACT_APP_MEDIA_NCQA_TERMSOFUSE} target="_blank" rel="noopener noreferrer">Terms of Use</a>
                </CopyrightText>
            </Grid>
        </StyledGrid>
    );
};

export default CopyrightBlock;
